import * as React from 'react';

interface Props {
  text: string | undefined;
}

export class TextCell extends React.Component<Props> {
  render() {
    return (
      <span>
        {this.props.text}
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/text/component.tsx